import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from 'antd';
import { AlimtalkSendFormValues } from '../../../types/alimtalk/form';
import { EventPickerModal, PickedEvent } from './EventPickerModal';
import * as Styled from './style';

export const EventSelectSection = () => {
  const { watch, setValue } = useFormContext<AlimtalkSendFormValues>();
  const eventId = watch('eventId');
  const [selectedEvent, setSelectedEvent] = useState<PickedEvent | null>(null);
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  const handleConfirm = (event: PickedEvent): void => {
    setSelectedEvent(event);
    setValue('eventId', event.eventId);
  };

  return (
    <Styled.Section>
      <Styled.SectionTitle>기획전 선택<Styled.RequiredMark>*</Styled.RequiredMark></Styled.SectionTitle>
      <Styled.SelectedList>
        {eventId && selectedEvent ? (
          <Styled.SelectedRow>
            <Styled.SelectedName>
              {selectedEvent.name} <Styled.IdBadge>#{eventId}</Styled.IdBadge>
            </Styled.SelectedName>
          </Styled.SelectedRow>
        ) : (
          <Styled.EmptyText>선택된 기획전이 없습니다.</Styled.EmptyText>
        )}
      </Styled.SelectedList>
      <Button onClick={() => setIsPickerOpen(true)}>기획전 선택</Button>

      <EventPickerModal open={isPickerOpen} onClose={() => setIsPickerOpen(false)} onConfirm={handleConfirm} />
    </Styled.Section>
  );
};
